import React, { useEffect, useRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import { useSetState } from 'utils/functions.utils';
import {
  Functions,
  Models,
  Header,
  PrimaryButton,
  Assets,
  BottomSheetComponent,
  UploadComponent,
} from 'utils/imports.utils';
import { testDispatch } from 'utils/redux.utils';
import './add_saree_popup.component.scss';

interface IAddSareePopup {
  text?: String;
  data?:any
}

const AddSareePopup = (props: IAddSareePopup) => {
  // Redux
  const testState = useSelector((state: any) => state.test);

  // State
  const [state, setState] = useSetState({
    images: [
      Assets.sareeImage,
      Assets.sareeImage,
      Assets.sareeImage,
      Assets.sareeImage,
      Assets.sareeImage,
      Assets.sareeImage,
    ],
  });

  //Hooks

  // Network req

  //Logic

  const sareeData = [{ sareeCount: '01' }, { sareeCount: '02' }];

  return (
    <div className="addsaree_popup_container">
      <BottomSheetComponent open={open} className="popup_bottomsheet">
        <div className="addsaree_popup_bottomsheet">
          <div className="addsaree_popup_header">
            <Header title="Add Saree" />
          </div>
          {sareeData.map((saree) => (
            <div className="addsaree_popup_wrapper">
              <div className="addsaree_popup_count">
                Saree {saree.sareeCount}
              </div>
              <div className="addsaree_popup_images_button">
                {/* <div className="addsaree_popup_button">
                <PrimaryButton
                  icon={Assets.camera_blue}
                  text="Add Saree"
                  className="add_saree_button"
                />
              </div> */}
                <div className="addsaree_popup_images_container">
                  <img src={Assets.camera} className="camera_icon" />
                  <div className="addsaree_popup_camera_gallery">
                    {state.images.map((image) => (
                      <div className="addsaree_popup_images_wrapper">
                        <img
                          src={image}
                          className="saree_images"
                          alt="saree image"
                        />
                        <img src={Assets.close} className="close_icon" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="addsaree_popup_footer">
            <div className="addsaree_popup_cancel_button">
              <PrimaryButton text="Cancel" className="cancel_button" />
            </div>
            <div className="addsaree_popup_deliver_button">
              <PrimaryButton text="Deliver" className="deliver_button" />
            </div>
          </div>
        </div>
      </BottomSheetComponent>
    </div>
  );
};

export default AddSareePopup;
